import type { ComponentProps, ComponentType } from 'svelte';

export enum Target {
    blank = '_blank',
    parent = '_parent',
    self = '_self',
    top = '_top',
}

export interface IconData {
    id: string;
    viewBox: string;
    url: string;
}

export enum Size {
    ExtraSmall = 'extra-small',
    Small = 'small',
    Medium = 'medium',
    Big = 'big',
}

export enum RelValue {
    nofollow = 'nofollow',
    noreferrer = 'noreferrer',
    noopener = 'noopener',
    bookmark = 'bookmark',
    previous = 'previous',
    next = 'next',
    tag = 'tag',
}

export interface DataAttrs {
    'data-role': string;
    'data-statistic-name': string;
    'data-id': string;
    'data-rel': string;
    'data-related': string;
    'data-tooltip': string;
    'data-counter': string;
    'data-track-url': string;
    'data-url': string;
    'data-testid': string;
    'data-value': string;
    'data-page': string;
    'data-block': string;
}

export enum Color {
    primary = 'primary',
    secondary = 'secondary',
    enabled = 'enabled',
    disabled = 'disabled',
    invert = 'invert',
    black = 'black',
    white = 'white',
    unset = 'unset',
    extraBlue = 'extra-blue',
    extraGreen = 'extra-green',
    extraViolet = 'extra-violet',
}

export enum TagName {
    A = 'a',
    Button = 'button',
    Div = 'div',
    Span = 'span',
}

// @deprecated Use TagName
export enum TagNameClickable {
    a = TagName.A,
    button = TagName.Button,
    div = TagName.Div,
}

export interface InnerComponent<C extends ComponentType> {
    component: C;
    props: ComponentProps<InstanceType<C>>;
    classes?: string;
}

export enum TriggerVisibilityMode {
    Always = 'always',
    Hover = 'hover',
}

export type HandlerFn = () => void;
export type HandlerWithElFn = (el: NullableType<HTMLElement>) => void;
export type HandlerWithEventFn = (e: Event) => void;

export enum Spacer {
    XS = 'xs',
    S = 's',
    M = 'm',
    L = 'l',
    XL = 'xl',
    XL2 = '2xl',
    XL3 = '3xl',
    XL4 = '4xl',
    XL5 = '5xl',
}
